module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "toc",
    attrs: {
      "id": "toc"
    }
  }, [_vm._v("Contents")]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/OEBPS/c01.htm"
    }
  }, [_vm._v("I. Question: When Is a Red Herring Blue?")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/OEBPS/c02.htm"
    }
  }, [_vm._v("II. The Mysterious Professor Kloop")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/OEBPS/c03.htm"
    }
  }, [_vm._v("III. Djuna Learns What a Fyke Is For")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/OEBPS/c04.htm"
    }
  }, [_vm._v("IV. Herrings Are Blue, Sure Enough!")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/OEBPS/c05.htm"
    }
  }, [_vm._v("V. An Old Address on Broadway")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/OEBPS/c06.htm"
    }
  }, [_vm._v("VI. Some Red Marks, Some Blue Marks")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/OEBPS/c07.htm"
    }
  }, [_vm._v("VII. Doc Perry Gets Mad at a Funny Song")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/OEBPS/c08.htm"
    }
  }, [_vm._v("VIII. Death Goes Fishing—in an Old Car")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/OEBPS/c09.htm"
    }
  }, [_vm._v("IX. Scapping Day")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/OEBPS/c10.htm"
    }
  }, [_vm._v("X. For Thrills, Try a Barn, a Shed, or a Museum!")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/OEBPS/c11.htm"
    }
  }, [_vm._v("XI. A Surprise Party")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('a', {
    attrs: {
      "href": "#/OEBPS/preview.htm"
    }
  }, [_vm._v("Preview: "), _c('i', [_vm._v("The Purple Bird Mystery")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-340136e6","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/OEBPS/toc.vue
// module id = 60
// module chunks = 0